import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem, Typography } from "@mui/material";
import { CircleUser, LogOut } from "lucide-react";
import { useAuth } from "@context/AuthContext";
import PromptDialog from "./PromptDialog";

const ProfileMenu: React.FC = () => {
  const { t } = useTranslation();
  const { logout, name } = useAuth();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="flex items-center">
      <div
        onClick={handleMenuOpen}
        color="inherit"
        className="flex flex-row gap-2 p-2 text-center align-middle justify-center hover:bg-gray-100 rounded-full cursor-pointer"
      >
        <CircleUser size={24} />{" "}
        <Typography className="hidden md:block">{name}</Typography>
      </div>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          sx={{
            pointerEvents: "none", // Prevent clicks
            opacity: 0.6, // Optional: Reduce opacity to indicate it's not interactive
            display: { xs: "block", sm: "none" }, // Hide on extra-small screens
          }}
        >
          {t("general.loggedInAs")}: {name}
        </MenuItem>

        <MenuItem
          onClick={() => {
            setLogoutDialogOpen(true);
            handleMenuClose();
          }}
        >
          <LogOut /> {t("general.logout")}
        </MenuItem>
      </Menu>

      <PromptDialog
        handleClose={() => setLogoutDialogOpen(false)}
        handleConfirm={() => logout()}
        isOpen={logoutDialogOpen}
        title={t("general.logout")}
        description={t("general.logoutPrompt")}
      />
    </div>
  );
};

export default ProfileMenu;
